export const getUrlIdentifier = (
    values: readonly { id: string | null; urlIdentifier: string | null }[],
    selectedId: string
): string | null | undefined => values.find((value: { id: string | null }) => value.id === selectedId)?.urlIdentifier;
